'use client';

import React from 'react';

import { Modal } from '@depop/web-ui-kit/Modal';
import { useTranslations } from 'next-intl';

import { SearchBar } from '@/components/SearchBar';
import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';
import { useSearchBarModal } from '@/modules/search/useSearchBarModal';

type Props = {
  className?: string;
};

export function VisibleSearchBar({ className }: Props) {
  const { isOpen, setIsOpen } = useSearchBarModal();
  const t = useTranslations('common');

  const { web_6599_search_bar_ds_rollout } = useExperiments([
    'web_6599_search_bar_ds_rollout',
  ]);
  const isDesignSystemVariant =
    web_6599_search_bar_ds_rollout === VARIANT_IDENTIFIER;

  return (
    <div className={className}>
      <SearchBar
        onFocus={() => setIsOpen(true)}
        isPlaceholderAnimated={false}
        placeholder={t('SearchBar.PlaceholderShort')}
      />
      <Modal
        hideCloseButton={isDesignSystemVariant}
        isOpen={isOpen}
        setOpen={setIsOpen}
        ignoreModalFocus
        content={() => (
          <SearchBar
            isAutoFocused
            sendATEventOnFocus={false}
            setIsOpen={setIsOpen}
          />
        )}
        title={t('Search.Placeholder')}
        id="search-bar-modal"
        overlayAriaLabel={t('Search.Placeholder')}
        testId="visibleSearchBar__modal"
        restoreFocus={false}
      />
    </div>
  );
}
